"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var TemplateContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TemplateContainer, _React$Component);

  function TemplateContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TemplateContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TemplateContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_template", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateSetter", function (cmp) {
      if (cmp) _this._template = cmp;
    });
    return _this;
  }

  (0, _createClass2.default)(TemplateContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._template;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          itemSelected = _this$props.itemSelected,
          anySelected = _this$props.anySelected,
          dragHandle = _this$props.dragHandle,
          commonProps = _this$props.commonProps;
      var Template = this.props.template;
      return _react.default.createElement(Template, {
        ref: this._templateSetter,
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: dragHandle,
        commonProps: commonProps
      });
    }
  }]);
  return TemplateContainer;
}(_react.default.Component);

exports.default = TemplateContainer;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-draggable-list/js/TemplateContainer.js
// module id = 1488
// module chunks = 0